import { useEffect } from "react";
import useExternalScript from "../../hooks/useExternalScript";

const ZenviaChat = () => {
  const zenviaScript: string =
    "https://static.zenvia.com/embed/js/zenvia-chat.min.js";
  const chatScript =
    'var chat = new ZenviaChat("e05d4c5214f6de4c945086d82beb5986").embedded("button").build();';

  const scriptStatus = useExternalScript(zenviaScript);

  useEffect(() => {
    if (scriptStatus === "ready") {
      const chatScriptElement = document.createElement("script");
      chatScriptElement.type = "application/javascript";
      chatScriptElement.innerHTML = chatScript;
      chatScriptElement.async = true;
      document.body.appendChild(chatScriptElement);
    }
  }, [scriptStatus]);

  return null;
};

export default ZenviaChat;
